var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4V10H4V4H6ZM4 24V18H6V24H4ZM7 14C7 15.11 6.11 16 5 16C4.60444 16 4.21776 15.8827 3.88886 15.6629C3.55996 15.4432 3.30362 15.1308 3.15224 14.7654C3.00087 14.3999 2.96126 13.9978 3.03843 13.6098C3.1156 13.2219 3.30608 12.8655 3.58579 12.5858C3.86549 12.3061 4.22186 12.1156 4.60982 12.0384C4.99778 11.9613 5.39992 12.0009 5.76537 12.1522C6.13082 12.3036 6.44318 12.56 6.66294 12.8889C6.8827 13.2178 7 13.6044 7 14ZM26 8V20C26 21.11 25.11 22 24 22H12C11.4696 22 10.9609 21.7893 10.5858 21.4142C10.2107 21.0391 10 20.5304 10 20V16L8 14L10 12V8C10 7.46957 10.2107 6.96086 10.5858 6.58579C10.9609 6.21071 11.4696 6 12 6H24C25.11 6 26 6.89 26 8Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistory);
export default __webpack_public_path__ + "static/media/order_history.8982035e7db752bcc13e41e2d4d53665.svg";
export { ForwardRef as ReactComponent };